export const translations = {
  ko: {
    nav: {
      home: '홈',
      about: '교회소개',
      worship: '예배안내',
      contact: '문의하기'
    },
    hero: {
      title: '"예수님과 함께 지어져 가는 교회"',
      verse: '(엡 4:16)',
      description: '환영합니다! 한소망교회는 예수 그리스도의 사랑으로 모든 성도가 하나되어 함께 성장하는 믿음의 공동체입니다.'
    },
    about: {
      title: '교회 소개',
      vision: '교회 비전',
      visionText: '예수 그리스도의 사랑으로 하나되어 함께 성장하는 교회',
      denomination: '교단',
      denominationText: '대한예수교장로회(합신)',
      pastor: '담임목사',
      pastorName: '임창섭 목사',
      location: '오시는 길',
      contact: '연락처',
      phone: '전화',
      email: '이메일'
    },
    worship: {
      title: '예배 시간',
      sunday: '주일 예배',
      sundayMain: '주일 낮 예배',
      sundayTime: '오전 11:00 ~',
      sundaySchool: '주일 학교',
      sundaySchoolTime: '오전 09:00 ~',
      wednesday: '수요 예배',
      wednesdayTime: '오후 7:30 ~',
      friday: '금요 기도회',
      fridayTime: '오후 8:30 ~',
      dawn: '새벽기도',
      dawnTime: '오전 5:30 ~ (월 ~ 금)'
    },
    youtube: {
      title: '말씀과 찬양',
      channelButton: 'YouTube 채널 바로가기',
      loading: '영상을 불러오는 중...',
      error: '영상을 불러오는 중 오류가 발생했습니다.',
      noVideos: '1월 예배 영상이 아직 없습니다.',
      comingSoon: '새로운 예배 영상이 곧 업로드될 예정입니다.'
    },
    contact: {
      title: '문의하기',
      name: '이름',
      email: '이메일',
      message: '메시지',
      submit: '보내기',
      success: '메시지가 성공적으로 전송되었습니다.',
      error: '메시지 전송 중 오류가 발생했습니다.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      worship: 'Worship',
      contact: 'Contact'
    },
    hero: {
      title: '"A Church Growing Together with Jesus"',
      verse: '(Ephesians 4:16)',
      description: 'Welcome! Hansomang Church is a community of faith where all believers grow together in the love of Jesus Christ.'
    },
    about: {
      title: 'About Us',
      vision: 'Our Vision',
      visionText: 'A church growing together in unity through the love of Jesus Christ',
      denomination: 'Denomination',
      denominationText: 'The Presbyterian Church in Korea (HapShin)',
      pastor: 'Senior Pastor',
      pastorName: 'Rev. Changseop Lim',
      location: 'Location',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email'
    },
    worship: {
      title: 'Service Times',
      sunday: 'Sunday Services',
      sundayMain: 'Sunday Worship',
      sundayTime: '11:00 AM ~',
      sundaySchool: 'Sunday School',
      sundaySchoolTime: '09:00 AM ~',
      wednesday: 'Wednesday Service',
      wednesdayTime: '7:30 PM ~',
      friday: 'Friday Prayer Meeting',
      fridayTime: '8:30 PM ~',
      dawn: 'Dawn Prayer',
      dawnTime: '5:30 AM ~ (Mon - Fri)'
    },
    youtube: {
      title: 'Sermons & Praise',
      channelButton: 'Visit YouTube Channel',
      loading: 'Loading videos...',
      error: 'Error loading videos',
      noVideos: 'January worship videos are not available yet.',
      comingSoon: 'New worship videos will be uploaded soon.'
    },
    contact: {
      title: 'Contact Us',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      submit: 'Send',
      success: 'Message sent successfully.',
      error: 'Error sending message.'
    }
  }
}; 